import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { baseURL1 } from './Redux/baseURL';
import {
	googleSuccess,
	login_success,
} from './Redux/ActionCreator';

const ProfileProtected = (props) => {
  // initialize useSelector hook
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuth = useSelector(prev => prev.login);
  const params = new URLSearchParams(window.location.search).get('token');
	const profile_stat = new URLSearchParams(window.location.search).get('profile_status');
	const acctType = new URLSearchParams(window.location.search).get('AcctType');
  console.log("Parameter", params);

  useEffect(() => {
		// const token = localStorage.getItem('token');
		if (params !== null) {
			localStorage.setItem('token', params);
			dispatch(googleSuccess({profile_status: profile_stat, AcctType: acctType}));
			dispatch(login_success({profile_status: profile_stat, AcctType: acctType}));
		}
	}, [params]);

  const handleRedirect = () => {
    if (params !== null) {
			localStorage.setItem('token', params);
			dispatch(googleSuccess({profile_status: profile_stat, AcctType: acctType}));
			dispatch(login_success({profile_status: profile_stat, AcctType: acctType}));
		} else {
      window.open(baseURL1 + `/welcome?link=${window.location.pathname}`, "_self");
    }
  }

  return (
    <>
    { isAuth.isAuthenticated === true ? props.children : handleRedirect() }
    </>
  )
}

export default ProfileProtected;

